var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:63.7268;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-width:44.4447;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 512,
    cy: 512,
    r: 465.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.99,817.33c-1.88-6.58-3.61-12.64-5.34-18.7c-24.18-84.58-48.32-169.17-72.56-253.73 c-5.77-20.13-5.3-39.9,3.64-58.94c12.52-26.68,33.58-42.7,62.71-47.23c41.07-6.39,80.97,20.79,90.78,61.26 c3.28,13.52,3.46,27.07-0.25,40.48c-6.54,23.61-13.32,47.16-20.04,70.72c-14.94,52.32-29.92,104.64-44.87,156.95 C521.41,784.37,516.77,800.61,511.99,817.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock3);
export default __webpack_public_path__ + "static/media/clock3.ba9fae9bfcbff8903357ab2db835969e.svg";
export { ForwardRef as ReactComponent };